<template>
  <div :id="this._uid" style="display: none">
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script type="text/babel">

  import MarkerClusterer from './markerclusterer'

  // We are not going to extend GoogleMapChildren because of differences in the destroy procedures
  export default {
    name: 'GoogleMapMarkerCluster',
    data() {
      return {
        item: null,
        markers: []
      }
    },
    mounted() {
      if (this.$parent.ready) {
        this.init()
      } else {
        this.$parent.$on('map-ready', () => {
          this.init()
        })
      }
    },
    methods: {
      getMap: function () {
        return this.$parent.getMap()
      },
      init: function () {
        if (typeof google == "undefined") {
          return
        }
        // Needed this to make the children markers initialize
        this.$emit('map-ready')
        this.markers = []
        this.$children.forEach((childrenMarker) => {
          this.markers.push(childrenMarker.item)
        })
        this.item = new MarkerClusterer(this.getMap(), this.markers, {
          imagePath: this.iconBase,
          maxZoom: 17
        })
      }
    },
    updated() {
      if (this.item) {
        this.item.clearMarkers()
      }
      this.init()
    },
    beforeDestroy() {
      if (this.item) {
        this.item.clearMarkers()
        delete this.item
      }
    },
    props: {
      // m1.png - m2.png - m3.png - m4.png - m5.png
      iconBase: {
        type: String,
        default: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
      }
    }
  }
</script>

<style>

</style>
